export default {
  data() {
    return {
      refreshing: false,
      registration: null,
      updateExists: false,
    };
  },
  created() {
    // Listen for our custom event from the SW registration
    // Setting the 'once' option to true allows the listener to be called only once AND removes the listener once invoked.
    document.addEventListener("swUpdated", this.updateAvailable, {
      once: true,
    });

    // prevent multiple refreshes
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (this.refreshing) {
        return;
      }

      this.refreshing = true;
      // Here the actual reload of the page occurs
      window.location.reload();
    });
  },
  methods: {
    updateAvailable(event) {
      console.group("updateAvailable")
      this.registration = event.detail;
      this.updateExists = true;
      console.warn("this.updateExists = ", this.updateExists)
      console.groupEnd();
    },
    refreshApp() {
      console.group("refreshApp");
      // Called when the user accepts the update

      this.updateExists = false;
      // Make sure we only send a 'skip waiting' message if the SW is waiting
      if (!this.registration || !this.registration.waiting) {
        console.warn("didn't need to SKIP_WAITING");
        console.groupEnd();
        return;
      }

      console.warn("SKIP_WAITING");
      // send message to SW to skip the waiting and activate the new SW
      this.registration.waiting.postMessage({ type: "SKIP_WAITING" });
      console.groupEnd();
    },
  },
};
